<template>
	<div
		class="banner-upload"
		v-loading="loading"
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-tooltip
			effect="dark"
			content="上传成功!"
			placement="top"
			v-model="tooltipShow"
			:manual="true">
			<p></p>
		</el-tooltip>
		<p class="error-msg" v-show="uploadError">上传失败!</p>
		<div v-if="previewSrc === '' && canEdit" class="banner-add el-icon-plus"  @mouseover="emptyImgMouseOver" @mouseout="emptyImgMouseOut">
			<div class="empty-img-btn" v-show="emptyBtnShow">
				<el-button class="upload-offline-btn" type="primary" @click="uploadHandler"><i class="el-icon-upload"></i></el-button>
			</div>
		</div>
		<div v-if="previewSrc !== ''" class="img-preview-block" @mouseover="imgMouseOver" @mouseout="imgMouseOut">
			<w-video :src="previewSrc" class="img-preview"></w-video>
			<div class="img-btn" v-show="activeFlag">
				<el-button v-if="canEdit" class="upload-btn" type="primary" @click="uploadHandler"><i class="el-icon-upload"></i></el-button>
				<el-button v-if="canEdit" class="delete-btn" type="danger" @click="deleteClick"><i class="el-icon-delete"></i></el-button>
				<el-button class="search-btn" type="danger" @click="previewClick"><i class="el-icon-search"></i></el-button>
			</div>
		</div>
		<input type="file" ref="file" id="file" accept="video/mp4" v-show="false" @change="getFile">
	</div>
</template>

<script>
export default {
	name: 'VideoUpload',
	props: {
		videoSrc: {
			type: String,
			default: ''
		},
		uploadError: Boolean,
		videoId: {
			type: String,
			default: '0'
		},
		hasFile: String,
		videoModal: Boolean,
		canEdit: {
			type: Boolean,
			default: true
		}
	},
	data () {
		return {
			previewSrc: '',
			uploadType: new RegExp(/video\/mp4/),
			uploadTypeText: 'mp4',
			uploadSize: 20,
			activeFlag: false,
			emptyBtnShow: false,
			loading: false,
			tooltipShow: false,
			tooltipTimer: null,
			fileFiles: ''
		}
	},
	created () {
		this.previewSrc = this.videoSrc
	},
	watch: {
		videoSrc (val) {
			this.previewSrc = val
			this.$refs.file.value = ''
			this.$emit('update:uploadError', false)
		}
	},
	methods: {
		previewClick () {
			this.$emit('update:videoModal', true)
		},
		emptyImgMouseOver () {
			this.emptyBtnShow = true
		},
		emptyImgMouseOut () {
			this.emptyBtnShow = false
		},
		imgMouseOver () {
			this.activeFlag = true
		},
		imgMouseOut () {
			this.activeFlag = false
		},
		uploadHandler () {
			this.$refs.file.click()
		},
		getFile (e) {
			this.$emit('update:uploadError', false)
			this.fileFiles = e.target.files[0]
			let files = e.target.files[0]
			let type = files.type
			let size = files.size / 1024 / 1024
			this.getDuration(files).then((res) => {
				if (res > 20) {
					this.$message.error(`上传视频时长不得大于20S!`)
					return false
				}
				if (!this.uploadType.test(type)) {
					this.$message.error(`上传视频只支持${this.uploadTypeText}格式!`)
					return false
				}
				if (size > this.uploadSize) {
					this.$message.error(`上传视频大小不能超过${this.uploadSize}M!`)
					this.$refs.file.value = ''
					this.previewSrc = ''
					this.$emit('update:uploadImgHandler', '')
					this.$emit('update:uploadError', false)
					return false
				}
				if (!e || !window.FileReader) {
					return false
				}
				let formData = new FormData()
				formData.append('extension', this.$refs.file.files[0].type.split('/')[1])
				formData.append('file', this.fileFiles)
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.urlQIVShop}/upload/video/temp`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.showTooltip()
						this.$emit('update:videoSrc', res.data)
						this.$emit('update:uploadError', false)
					} else {
						this.$message.error('上传视频失败')
						this.$emit('update:uploadError', true)
					}
				}).catch(() => {
					this.$emit('update:uploadError', true)
				})
			})
		},
		getDuration (files) {
			return new Promise((resolve, reject) => {
				let url = URL.createObjectURL(files)
				let audioElement = new Audio(url)
				audioElement.addEventListener('loadedmetadata', () => {
					resolve(parseInt(audioElement.duration))
				})
			})
		},
		deleteClick () {
			this.$confirm('是否删除该视频？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.$refs.file.value = ''
				this.previewSrc = ''
				this.$emit('update:videoSrc', '')
				this.$emit('update:uploadError', false)
			}).catch(() => {})
		},
		showTooltip () {
			this.tooltipShow = true
			if (this.tooltipTimer) {
				clearTimeout(this.tooltipTimer)
			}
			this.tooltipTimer = setTimeout(() => {
				this.tooltipShow = false
			}, 1500)
		}
	}
}
</script>
<style lang="stylus" scoped>
/deep/.el-loading-mask {
	height: 80px
	margin-top: 20px
	border-radius: 6px;
}
.banner-upload {
	width: 80px;
	height: 100px;
	border-radius: 6px;
	overflow: hidden;
	box-sizing:border-box
	position:relative
	padding-top:20px
	margin-right: 20px
	float left
	.error-msg {
		color:red
		position:absolute
		top:0
		left:0
		text-align center
	}
	.banner-add,.img-preview-block {
		border-radius: 6px;
		overflow: hidden;
		box-sizing:border-box
		width: 80px;
		height: 80px;
		line-height: 80px;
		display: inline-block
	}
	.banner-add {
		border: 1px dashed #d9d9d9;
		cursor: pointer;
		position: relative;
		text-align: center;
		font-size: 28px;
		color: #8c939d;
		// &:hover {
		// 	border-color: var(--fx-primary-color);
		// }
		.empty-img-btn {
			position: absolute
			top:0px
			right:0px
			height:100%
			width:100%
			background-color:rgba(0,0,0,0.1)
			text-align center
			.el-button {
				padding: 4px
				text-align center
				position absolute
			}
			.upload-offline-btn {
				top: 27px;
				left: 27px;
			}
			.upload-online-btn {
				top: 24px;
				right: 10px;
			}
		}
	}
	.img-preview-block {
		position:relative
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		.img-preview {
			width:100%
			height:100%
		}
		.img-btn {
			position: absolute
			top:0px
			right:0px
			height:100%
			width:100%
			background-color:rgba(0,0,0,0.1)
			text-align center
			.el-button {
				padding: 4px
				text-align center
				position absolute
			}
			.upload-btn {
				top: 14px;
				left: 10px;
			}
			.delete-btn {
				top: 14px;
				right: 10px;
			}
			.search-btn {
				bottom 8px
				left 18px
			}
		}
	}
}
</style>
